import { reactive } from 'vue'

/**
 * 예약 팝업 편집 이탈 가드.
 *
 * 팝업 왼쪽의 편집 컴포넌트(기본정보·예약메모)가 편집 중일 때, 팝업 닫기·예약 이동 등
 * 이탈 액션이 실행되기 전에 "저장하시겠습니까?" 확인 알럿을 거치도록 한다.
 * - 편집 컴포넌트: 표시될 때 registerGuard 로 자신의 확인 알럿 핸들러를 등록
 * - 이탈 액션: invokeGuard 를 await 해 사용자의 선택(계속 진행 여부)을 받는다
 *
 * 구 ReservationPopupDataController 의 함수 레지스트리를 1:1 대체한다.
 */

type GuardType = 'AlertEditUserBasicInfo' | 'AlertEditUserNote'

/** 편집 컴포넌트가 알럿을 띄우고, 사용자의 선택으로 resolve 를 호출한다 (false = 이탈 취소) */
type GuardHandler = (resolve: (result?: boolean) => void) => void

/** 컴포넌트 data 에 담아 반응형으로 구독하는 편집 상태 플래그 */
export const editGuardState = reactive({
    isEditBasicInfo: false,
    isUserNoteChanged: false
})

export function setEditBasicInfo(isEditBasicInfo?: boolean): void {
    editGuardState.isEditBasicInfo = isEditBasicInfo ?? false
}

export function setUserNoteChangedStatus(isUserNoteChanged?: boolean): void {
    editGuardState.isUserNoteChanged = isUserNoteChanged ?? false
}

const handlers: Partial<Record<GuardType, GuardHandler>> = {}

export function registerGuard(type: GuardType, handler: GuardHandler): void {
    handlers[type] = handler
}

export function unregisterGuard(type: GuardType): void {
    handlers[type] = undefined
}

export function invokeGuard(type: GuardType): Promise<boolean | undefined> {
    return new Promise(resolve => {
        const handler = handlers[type]
        if (typeof handler === 'function') {
            handler(resolve)
        } else {
            // 편집 컴포넌트가 표시되지 않았다면 등록도 없다 — 구 코드와 동일하게 false 폴백
            console.log(`${type} guard is not registered`)
            resolve(false)
        }
    })
}
